exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Uid2n5RdsN3dSw6S4LkjW ._2FdaAHv3cBC_njLUe9WXx4{position:absolute;top:0;background:#fff}._1Uid2n5RdsN3dSw6S4LkjW .xFuljJFmq8jVOdw7Dg2Mv ._3ztJPM010vQhuyyN-J-9BJ{position:absolute;height:100%}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_1Uid2n5RdsN3dSw6S4LkjW",
	"lines-decorations": "_2FdaAHv3cBC_njLUe9WXx4",
	"margin-view-overlays": "xFuljJFmq8jVOdw7Dg2Mv",
	"cldr": "_3ztJPM010vQhuyyN-J-9BJ"
};